@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <div class='file-input-controller'>
      <label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </label>
      @if (!inputService.inputConfig.readOnly && !inputService.control.value) {
        <div class='file-drop-zone'
          [class.dragging]='dragging'
          (dragleave)='onFileDragLeave($event)'
          (dragstart)='onFileDragStart($event)'
          (dragover)='onFileDragOver($event)'
          (drop)='onFileDrop($event)'
          >
          <mat-icon>cloud_download</mat-icon>
          <span>{{'Carica un file' | translate}}</span>
          <input #fileInput (change)="onFileChange($event)" type='file'/>
        </div>
      }
      @if (inputService.control.value) {
        <div class='file-loaded'>
          <mat-icon>insert_drive_file</mat-icon>
          @if (!inputService.inputConfig.readOnly) {
            <button mat-icon-button (click)='clearFile()'>
              <span class="material-icons">close</span>
            </button>
          }
        </div>
      }
    </div>
  </ng-container>
}